import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./InfoBlockWithIcon.module.scss";

interface Props {
  action?: React.ReactNode;
  className?: string;
  icon: IconProp;
  iconColor: "blue" | "green" | "red" | "yellow";
  subTitle?: string;
  title: string;
}

const InfoBlockWithIcon: React.FC<Props> = ({
  action,
  className,
  icon,
  iconColor,
  subTitle,
  title,
}) => (
  <div className={cn(styles.container, className)}>
    <div className={cn([styles.iconContainer, styles[iconColor]])}>
      <FontAwesomeIcon icon={icon} size="xs" />
    </div>
    <div>
      <p className={styles.title}>{title}</p>
      {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
      {action && <div>{action}</div>}
    </div>
  </div>
);

export default InfoBlockWithIcon;
